import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import type { ReactElement } from "react";

export function FitSettingsSkeleton(): ReactElement {
  return (
    <Card>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between gap-4">
          <div className="min-w-0 space-y-1">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-3 w-64" />
          </div>
          <Skeleton className="h-9 w-64 shrink-0" />
        </div>
      </CardContent>
    </Card>
  );
}
